{
  "version": 1,
  "asset_id": "d4547512-f223-45d1-b1da-f31330285cc5",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d4547512-f223-45d1-b1da-f31330285cc5/destination-roofing-owner-sales-team-crystal-river-fl-360w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d4547512-f223-45d1-b1da-f31330285cc5/destination-roofing-owner-sales-team-crystal-river-fl-360w.avif",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-360w.avif",
  "size": 8056,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:45Z"
}
